export const environment = {
  production: false,
  apiUrl: 'https://uslegalization-platform.efrx.com/api',
  acceptJSLink: 'https://jstest.authorize.net/v3/AcceptUI.js',
};
